"use client"

import type React from "react"

const SPANISH_TEXT = {
  genericError: "Ocurrió un error. Por favor, inténtalo de nuevo.",
}

interface FormContainerProps {
  children: React.ReactNode
  formError?: string | null
  onSubmit?: (e: React.FormEvent) => void
}

export const FormContainer: React.FC<FormContainerProps> = ({ children, formError, onSubmit }) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    e.stopPropagation()
    if (onSubmit) {
      onSubmit(e)
    }
  }

  return (
    <div className="flex-1">
      <form id="native-form" onSubmit={handleSubmit}>
        {children}

        {formError && <div className="mb-3 text-center text-base text-red-500">{formError === "generic" ? SPANISH_TEXT.genericError : formError}</div>}
      </form>
    </div>
  )
}
